import { cn } from "@/lib/utils";

export const Annotation = ({ children, className = "", dark = false, dot = false, as: Tag = "span", ...rest }) => (
  <Tag
    className={cn("mono-label inline-flex items-center gap-2 whitespace-nowrap", dark ? "text-paper/55" : "text-ink/55", className)}
    {...rest}
  >
    {dot && <span className="h-1.5 w-1.5 bg-accent" aria-hidden="true" />}
    {children}
  </Tag>
);

export const SectionHead = ({ index, label, right, dark = false, className = "" }) => (
  <div className={cn("flex items-center justify-between border-t pt-4", dark ? "hl-light" : "hl", className)}>
    <Annotation dark={dark}>
      {index} <span className="opacity-40">/</span> {label}
    </Annotation>
    {right && (
      <Annotation dark={dark} className="hidden sm:inline-flex">
        {right}
      </Annotation>
    )}
  </div>
);
